import { render, staticRenderFns } from "./BoxesFilter.vue?vue&type=template&id=9b9e278c&scoped=true&"
import script from "./BoxesFilter.vue?vue&type=script&lang=js&"
export * from "./BoxesFilter.vue?vue&type=script&lang=js&"
import style0 from "./BoxesFilter.vue?vue&type=style&index=0&id=9b9e278c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9e278c",
  null
  
)

export default component.exports